/**
 * Hook React Query para delegar aprobación workflow (0668).
 *
 * Consume endpoint legacy `POST /workflow/instancias/:tipo/:id/delegar`
 * (creado en 0662). Tras delegar exitosamente invalida `actionCenter.list`
 * + `actionCenter.count` para que la fila desaparezca de la bandeja del
 * actor (la pasa al delegado).
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { request } from '../../../shared/services/api';
import type { ArtefactoWorkflowTipo } from './useActionCenterDetail';

export interface DelegarParams {
  tipo: ArtefactoWorkflowTipo;
  id: string;
  delegadoUserId: string;
  motivo: string;
  fechaFin?: string | null;
}

export function useDelegarWorkflow() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DelegarParams) => {
      return request(`/workflow/instancias/${params.tipo}/${params.id}/delegar`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          delegadoUserId: params.delegadoUserId,
          motivo: params.motivo,
          fechaFin: params.fechaFin ?? null,
        }),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['actionCenter', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['actionCenter', 'count'] });
    },
  });
}
